import makeStyles from '@material-ui/core/styles/makeStyles';
import {getDate} from '../../../../../../@casino/lib/getDate';

const useStyles = makeStyles(() => ({
    wrapTitle: {
        paddingLeft: 8,
        paddingBottom: '6px',
        marginTop: 20,
        paddingTop: '4px',
        marginBottom: '8px',
        borderBottom: '1px solid #ccc',
        width: '97%',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: 12,
    },
    title: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '14px',
        lineHeight: '17px',
        userSelect: 'none',
        fontFamily: 'PT Sans,sans-serif',
        color: '#fff',
    },
    arrow: {
        fill: '#fff', 
        width: 10, 
        height: 10
    }
}));

const columns = [
    { id: 'id', label: 'ID'},
    { id: 'date', label: 'Дата'},
    { id: 'summ', label: 'Сумма'},
    { id: 'payment', label: 'Платежная система'},
    { id: 'transaction', label: 'ID транзакции'},
    { id: 'login', label: 'Логин кассира'},
];

const getRows = (withdrawals) => {

    return withdrawals.map((item) => {
        return {
            id: item.id,
            date: getDate(item.event_date),
            summ: `${new Intl.NumberFormat('ru-RU').format(item.summ.toFixed(2)) + '₽'}${item.air ? '(Отжат воздух)' : ''}`, 
            payment: item.payment,
            transaction: item.id_transcation ? item.id_transcation : '-',
            login: item.login,
        }
    })
} 

export {
    useStyles,
    getRows,
    columns
}